import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ActiveCartFacade, Cart } from "@spartacus/cart/base/root";
import { Observable, Subject } from "rxjs";
import { I18nModule, WindowRef } from "@spartacus/core";
import { Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { GenPaymentTypeEnum } from 'src/app/generac/enums/payment-type.enum';
import { CommonModule } from '@angular/common';
import { Order } from '@spartacus/order/root';

@Component({
  selector: 'gen-order-summary',
  templateUrl: './order-summary.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    I18nModule,
  ]
})
export class GenOrderSummaryComponent implements OnInit {
  private destroy$ = new Subject();
  protected readonly PaymentType = GenPaymentTypeEnum;

  @Input() set data(data: Observable<Cart | Order>) {
    this.data$ = data;
  };

  @Input() showInfoDAOrder = true;
  isServicePartsEnabled: boolean = false;
  data$: Observable<Cart | Order>;
  cartOrDeliveryAddressStep: boolean;

  constructor(
    protected activeCartFacade: ActiveCartFacade,
    protected winRef: WindowRef,
    protected cdr: ChangeDetectorRef,
    private router: Router,
  ) {
    this.router.events.pipe(
      takeUntil(this.destroy$),
    ).subscribe((event: any) => {
      if (event.url) {
        this.cartOrDeliveryAddressStep = event.url?.indexOf('/cart') > -1 || event.url?.indexOf('/checkout/delivery-address') > -1;
      }
      this.cdr.markForCheck();
    });
  }

  ngOnInit() {
    if (!this.data$) {
      this.cartOrDeliveryAddressStep = this.winRef.location.href?.indexOf('/cart') > -1 || this.winRef.location.href?.indexOf('/checkout/delivery-address') > -1;
      this.data$ = this.activeCartFacade.getActive();
    }
    this.isServicePartsEnabled = JSON.parse(this.winRef.localStorage.getItem('isServicePartsEnabled'));
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);;
    this.destroy$.complete();
  }
}
